
import {Vue, Component} from 'vue-property-decorator';
import axios from "axios";

const client = axios.create({
  baseURL: process.env.VUE_APP_APIGW_URL,
})
const customConfig = {
  headers: {
    'Content-Type': 'application/json'
  }
}

@Component({})
export default class Register extends Vue {
  $refs!: {
    form: HTMLFormElement
    submit: HTMLButtonElement
  }

  expTypeArray = ["E 타입"]
  orgArray = ["중앙대병원 (A)", "원광대병원 (B)"]
  watchArray = ["iOS(애플워치)", "AOS(갤럭시워치)"]

  serviceType = 0
  expType = 0
  org = 0
  watch = 0

  disabled = false
  result = ""
  error = null

  reset(): void {
    this.serviceType = 0
    this.expType = 0
    this.org = 0
    this.watch = 0
    this.result = ""
    this.error = null
  }

  validate(): boolean {
    return (this.serviceType != 0)
  }

  submit(): void {
    if (this.validate()) {
      this.disabled = true

      switch (this.serviceType) {
        case 1:
          this.registerAttendee()
          break
        case 2:
          this.registerTestAttendee()
          break
      }

    }
  }

  copy(): void {
    navigator.clipboard.writeText(this.result)
  }

  registerTestAttendee(): void {
    client.get(
        '/alxn/v1/attendee/test/register.do', customConfig
    ).then((r) => {
      if (r.data) {
        console.log("received test attendee " + JSON.stringify(r.data))

        this.result = r.data["data"]["prescription"] + " | " + r.data["data"]["confirmCode"]
        this.error = null
      }
      this.disabled = false
    }).catch((error) => {
      this.disabled = false
      if (error.response) {
        if (error.response.status == 418) {
          this.error = error.response.data?.message
          console.log(error.response.data)
        } else {
          this.error = error
        }
      } else {
        console.log(error.message)
        this.error = error
      }
    })
  }

  registerAttendee(): void {
    let exOrder = "NOS1"
    let exType = ""
    switch (this.expType) {
      case 0:
        exType += "E"
        break
    }

    let exOrg = ""
    switch (this.org) {
      case 0:
        exOrg += "A"
        break
      case 1:
        exOrg += "B"
            break
    }

    const requestBody = JSON.stringify({
      exOrder: exOrder,
      exType: exType,
      exOrg: exOrg,
      subjectType: this.watch,
    })

    console.log("request: ", requestBody)

    client.post(
        "/alxn/v1/attendee/register.do", requestBody, customConfig
    ).then((r) => {
      if (r.data) {
        console.log("received response " +  JSON.stringify(r.data))

        this.result = r.data["data"]["prescription"] + " | " + r.data["data"]["confirmCode"]
        this.error = null
      }
      this.disabled = false
    }).catch((error) => {
      this.disabled = false
      if (error.response) {
        if (error.response.status == 418) {
          this.error = error.response.data?.message
          console.log(error.response.data)
        } else {
          this.error = error
        }
      } else {
        console.log(error.message)
        this.error = error
      }
    })
  }

}
